// extracted by mini-css-extract-plugin
export var border = "Heading-module--border--1e071";
export var bottom = "Heading-module--bottom--0aa1e";
export var center = "Heading-module--center--00b11";
export var colorDefault = "Heading-module--colorDefault--a6260";
export var colorWeak = "Heading-module--colorWeak--6fdbc";
export var container = "Heading-module--container--672d3";
export var dividerText = "Heading-module--dividerText--9d9ef";
export var l = "Heading-module--l--4fbc2";
export var left = "Heading-module--left--23953";
export var xm = "Heading-module--xm--b2128";
export var xxm = "Heading-module--xxm--5f5f8";